import React, { Fragment, useState, useEffect, useRef } from "react";
import { v4 as uuid } from "uuid";
import iconUpload from "../../assets/iconUpload.svg";

const InputFile = ({
  getFiles = () => {},
  maxSizeAllFile = 10, // PESO TOTAL DE LOS ARCHIVOS EN MB
  maxSizebyFile = 0, // PESO INVIDIUAL DE LOS ARCHIVOS EN MB
  //   emptyFile = "",
  filesDefault = [],
  disabled = false,
  title,
  labelMessage = "Máx. 5 MB por archivo y hasta 15 MB en total Formatos JPG, PNG y PDF",
  renderHeaderList,
  renderItem,
  onlyItem = false,
  acceptFiles = "image/x-png,image/jpeg,application/pdf,.heic",
  customInputFile = null,
  multiple = false,
  hideListItems = false,
  hideMessageErrors = false,
  customErrors = null,
}) => {
  const refInput = useRef();
  const SIZE_MB = 1024 * 1024;
  const MAX_SIZE = SIZE_MB * maxSizeAllFile;
  const MAX_SIZE_BY_FILE = SIZE_MB * maxSizebyFile;

  const [files, setFiles] = useState(filesDefault);
  const [isOver, setIsOver] = useState(false);
  const [isExcessWight, setIsExcessWight] = useState({});

  const ext = ["image/png", "image/jpeg", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/xml"];
  const RenderItem = renderItem;

  const onChangeFile = async (e) => {
    const fileList = [];
    const sizeFileList = getSizeFileList(files);
    let sizeFileCurrent = 0;
    let listErrors = [];
    setIsExcessWight({
      status: false,
      name: "",
    });
    if (sizeFileList <= MAX_SIZE) {
      for (const item of e.target.files) {
        // if (!isAllowedFile(item)) continue;
        if (!isAllowedSizeByFile(item)) {
          setIsExcessWight({
            status: true,
            name: item.name,
            isToltalFile: false,
          });
          listErrors.push({ name: item.name, type: "individual" });
          continue;
        }

        if (sizeFileList + sizeFileCurrent + item.size <= MAX_SIZE) {
          sizeFileCurrent = sizeFileCurrent + item.size;
          fileList.push({ file: await getDataFiles(item) });
        } else {
          setIsExcessWight({
            status: true,
            name: item.name,
            isToltalFile: true,
          });
          listErrors = [{ name: item.name, type: "total" }];
          break;
        }
      }

      getFiles(fileList, listErrors);
    }
    if (refInput.current) {
      refInput.current.value = "";
    }
  };

  const isAllowedSizeByFile = (item) =>
    !!MAX_SIZE_BY_FILE ? item.size <= MAX_SIZE_BY_FILE : true;

  useEffect(() => {
    // console.log("filesDefault", filesDefault);
    setFiles(filesDefault);
  }, [filesDefault]);

  const getSizeFileList = (files) => {
    const reducer = (accumulator, item) => accumulator + item.file.size;
    return files.reduce(reducer, 0);
  };

  const isFileHEIC = (name) => {
    const extFile = name.split(".").pop();
    return extFile === "heic";
  };

  const isAllowedFile = (file) =>
    ext.includes(file.type) || isFileHEIC(file.name);

  const getDataFiles = async (file) => {
    let uint8Array = "";
    //if (isFileHEIC(file.name)) {
      const buffer = await file.arrayBuffer();
      uint8Array = new Uint8Array(buffer);
    //}
    return {
      key: Math.random(),
      type: file.type,
      name: file.name,
      size: file.size,
      content: await readFile(file),
      buffer: uint8Array,
    };
  };

  const readFile = (file) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
      };
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  };

  const renderInput = () => (
    <input
      className="rd--file__input"
      id="files"
      type="file"
      ref={refInput}
      multiple={multiple}
      onChange={onChangeFile}
      onDrop={() => setIsOver(false)}
      onDragEnter={() => setIsOver(true)}
      onDragLeave={() => setIsOver(false)}
      // accept={acceptFiles}
    />
  );

  const renderWrapper = () => {
    if (customInputFile) {
      return (
        <div className="rd--file__custom">
          {customInputFile}
          {renderInput()}
        </div>
      );
    }
    return (
      !onlyItem && (
        <div
          className={`rd--file__upload ${
            isOver ? "rd--file__upload--over" : ""
          }`}
        >
          <div className="rd--file-data">
            {/* {emptyFile && (
              <img
                src={`../../assets/${emptyFile}.png`}
                alt="File imagess"
                className="rd--file-data__icon"
              />
            )} */}
            <img
              src={iconUpload}
              alt="File imagess"
              className="rd--file-data__icon"
            />
            <div className="rd--file-data__text">
              <div
                className="rd--file-data__text--mobile"
                dangerouslySetInnerHTML={{ __html: title.mobile }}
              ></div>
              <div
                className="rd--file-data__text--desktop"
                dangerouslySetInnerHTML={{ __html: title.desktop }}
              ></div>
            </div>
            <p className="rd--file-data__format">{labelMessage}</p>
          </div>
          {renderInput()}
        </div>
      )
    );
  };

  const renderErrors = () => {
    if (isExcessWight.status && !hideMessageErrors) {
      if (customErrors) {
        return <Fragment>{customErrors(isExcessWight)}</Fragment>;
      }
      return (
        <div className="rd--file__alert">
          <div className="rd--file__icon-error">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.7945 11.7583L9.42202 2.7768C8.80659 1.74107 7.19319 1.74107 6.57777 2.7768L1.2053 11.7583C0.606508 12.7632 1.38826 13.9999 2.63574 13.9999H13.3807C14.6115 14.0153 15.3933 12.7786 14.7945 11.7583Z"
                fill="#FFA733"
              />
              <path
                d="M8.08352 4.86877H7.8364C7.47523 4.86877 7.17108 5.15734 7.19009 5.50001L7.30415 9.30237C7.30415 9.46469 7.43721 9.5729 7.58928 9.5729H8.33064C8.48272 9.5729 8.61578 9.44665 8.61578 9.30237L8.72984 5.50001C8.74884 5.15734 8.4447 4.86877 8.08352 4.86877Z"
                fill="white"
              />
              <path
                d="M7 11.4305C7 11.9355 7.43721 12.3503 7.96947 12.3503C8.52073 12.3503 8.95794 11.9355 8.93894 11.4305C8.93894 10.9255 8.50173 10.5107 7.96947 10.5107C7.43721 10.5107 7 10.9255 7 11.4305Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="rd--file__message">
            {isExcessWight.isToltalFile && (
              <Fragment>
                {isExcessWight.name} no se cargó porque excede la capacidad
                máxima total ({maxSizeAllFile} MB).
              </Fragment>
            )}
            {!isExcessWight.isToltalFile && (
              <Fragment>
                {isExcessWight.name} no se cargó porque excede la capacidad
                máxima por archivo ({maxSizebyFile} MB).
              </Fragment>
            )}
          </div>
        </div>
      );
    }
  };

  const deleteFileFromRenderItem = (itemIndex) => {
    let listFile = files.filter((file, index) => index !== itemIndex);
    setFiles(listFile);
  };

  return (
    <div className={`rd--file ${disabled ? "rd--file__disabled" : ""}`}>
      {renderWrapper()}
      {renderErrors()}
      {files.length > 0 && !hideListItems ? (
        <Fragment>
          <div className="rd--file-list__head">{renderHeaderList}</div>
          <div className="rd--file-list">
            {files.map((item, index) => (
              <RenderItem
                key={uuid()}
                data={item}
                id={index}
                deleteAction={deleteFileFromRenderItem}
              />
            ))}
          </div>
        </Fragment>
      ) : null}
    </div>
  );
};

export default InputFile;
